<template>
    <client-page>
        <v-container>
            <div class="tit-wrap text-center">
                <h2 class="tit tit--lg">Permanent Sales</h2>
            </div>

            <div class="tab-wrap">
                <auction-program-search v-bind="{ totalCount }" onlySearch />
            </div>

            <div class="tab-wrap">
                <auction-category-select :value="category" v-bind="{ categories }" returnObject @input="(category) => $router.push(`/permanent-sales/groups/${category?.code || 'all'}`)" cols="6" sm="4" md="3" />
            </div>

            <div>
                <auction-work-list :works="works" class="gallery-card-row" />
            </div>

            <div class="v-pagination-wrap">
                <v-pagination :value="page" :length="pageCount" :total-visible="11" class="mt-8 mb-16" @input="(page) => $router.push({ query: { ...this.$route.query, page } })" />
            </div>
        </v-container>

        <v-fade-transition leave-absolute>
            <v-overlay v-show="loading" color="white" light>
                <v-progress-circular color="primary" indeterminate size="100" width="5" />
            </v-overlay>
        </v-fade-transition>
    </client-page>
</template>

<script>
import api from "@/api";
import { mapActions } from "vuex";
import { AUCTION_CATEGORY_GROUPS, WORK_AUCTION_MODES } from "@/assets/variables";

import ClientPage from "@/pages/client/templates/ClientPage.vue";
import AuctionWorkList from "@/components/client/auction/auction-work-list.vue";
import AuctionProgramSearch from "@/components/client/auction/programs/auction-program-search.vue";
import AuctionCategorySelect from "@/components/client/auction/categories/auction-category-select.vue";

export default {
    components: {
        ClientPage,
        AuctionWorkList,
        AuctionProgramSearch,
        AuctionCategorySelect,
    },
    props: {
        group: { type: String, default: "all" },
    },
    data: () => ({
        loading: false,

        works: [],

        totalCount: 0,
        limit: 20,
    }),
    computed: {
        categories() {
            return this.$store.state.categories.filter(({ group }) => group == AUCTION_CATEGORY_GROUPS.PERMANENT.value);
        },
        sort() {
            return this.$route.query.sort || "lot_desc";
        },
        searchKey() {
            return this.$route.query.searchKey || null;
        },
        searchValue() {
            return this.$route.query.searchValue || null;
        },
        page() {
            return +this.$route.query.page || 1;
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.totalCount / this.limit) || 1;
        },
        headers() {
            const { skip, limit } = this;
            return { skip, limit };
        },
        category() {
            return this.getCategory(this.group);
        },
        params() {
            const { category, sort, searchKey, searchValue } = this;

            const params = { mode_auction: WORK_AUCTION_MODES.PERMANENT.value, _category: category?._id, sort, searchKey, searchValue };

            if (!params._category) delete params._category;

            return params;
        },
    },
    mounted() {
        this.getCategories();
        this.init().then(this.search);
    },
    watch: {
        params() {
            this.init().then(this.search);
        },
    },
    methods: {
        ...mapActions(["getCategories"]),
        async init() {
            this.works = [];
            this.totalCount = 0;

            let path = `/permanent-sales/groups/${this.group}`;
            if (this.$route.path != path) this.$router.replace({ path, query: this.$route.query });
        },
        async search() {
            if (this.loading) return;
            else this.loading = true;
            try {
                const { headers, params } = this;
                var {
                    summary: { totalCount },
                    works,
                } = await api.v1.auction.works.gets({ headers, params });

                this.works = works;
                this.totalCount = totalCount;
            } finally {
                this.loading = false;
            }
        },

        getCategory(code, categories = this.categories) {
            const category = categories.find((item) => item.code == code);
            if (category) return category;

            const children = categories.flatMap(({ children }) => children);
            if (children.length) return this.getCategory(code, children);

            return null;
        },
    },
};
</script>
